// TODO: Split this up, it's confusing to import '.#/components/common'

import React from 'react';
import styled from 'styled-components';

import { handleOpacity, remify, safeUrl } from '#/service/utils';

interface FillDivProps {
  backgroundColor?: string;
  backgroundImage?: string;
  color?: string;
  opacity?: number;
}

/** Absolute positioned div covering its parent */
export const FillDiv = styled.div<FillDivProps>`
  position: absolute;
  inset: 0;
  ${({ backgroundColor, opacity }) =>
    backgroundColor &&
    `background-color: ${
      opacity ? handleOpacity(backgroundColor, opacity) : backgroundColor
    };`}
  ${({ backgroundImage }) =>
    backgroundImage &&
    `background: url('${backgroundImage}') center center / 100% 100%;`}
  ${({ color }) => color && `color: ${color};`}
`;

FillDiv.displayName = 'FillDiv';

// Line clamped paragraph
interface LineClampTextProps {
  lines: number;
}

export const LineClampText = styled.p<LineClampTextProps>`
  display: -webkit-box;
  -webkit-line-clamp: ${({ lines }) => lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

LineClampText.displayName = 'LineClampText';

interface ReactMarkdownProps {
  node: object;
}

export const ReactMarkdownBlankLink = (
  props: React.ClassAttributes<HTMLAnchorElement> &
    React.AnchorHTMLAttributes<HTMLAnchorElement> &
    ReactMarkdownProps
) => {
  const { href = '', node: _node, children } = props;

  return (
    <a
      {...props}
      href={safeUrl(href)}
      rel="noopener noreferrer"
      target="_blank"
    >
      {children}
    </a>
  );
};

ReactMarkdownBlankLink.displayName = 'BlankLink';

export const PageHeading = styled.h2`
  font: var(--fontStyleHeadline);
  color: var(--pageHeadingForeground);
  margin: ${remify(15)} 0 ${remify(45)};
  text-align: center;
`;
